const { isUndNullEmpNew } = require('../../helpers/UtilsHelper');

export class LlmModelClass {
    constructor(
        id = '',
        llmId = '',
        code = '',
        description = '',
        enabled = false,
        userId = '',
        created = new Date()?.toISOString(),
    ) {
        this.id = id;
        this.llmId = llmId;
        this.code = code;
        this.description = description;
        this.enabled = enabled;
        this.userId = userId;
        this.created = created;
    }

    static getClassName = () => {
        return 'Large language Model - models - classs';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new LlmModelClass(
                obj?.id,
                obj?.llmId,
                obj?.code,
                obj?.description,
                obj?.enabled,
                obj?.userId,
                obj?.created,
            );
        }
    }
}